import {
  IWebsiteBuilderBox,
  websiteBuilderGenerateBoxDesignStyles,
} from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderBox";
import React, { ReactNode } from "react";

interface IWebsiteBuilderBoxViewProps {
  node: IWebsiteBuilderBox;
  children: ReactNode;
  elementChildMoving: boolean;
}

export function WebsiteBuilderBoxView(props: IWebsiteBuilderBoxViewProps) {
  const { node, children, elementChildMoving } = props;

  const settings = node.container.settings;
  const designStyles = websiteBuilderGenerateBoxDesignStyles(settings);

  return (
    <div
      className={designStyles.className}
      style={{
        ...designStyles.styleProperties,
        ...(elementChildMoving ? { position: "static" } : {}),
      }}
    >
      {children}
    </div>
  );
}
